import RouterConfig from "./RouterConfig";
import Components from "./components";
import Store from "./store";
import Tabs from "./tabs";
import {companyInfoView, CompanyInfoView} from "./view/CompanyInformationViewComponent";

const ModuleName = "tfApp.company-information";

export default angular.module(ModuleName, [Components(ModuleName), Store(ModuleName), Tabs(ModuleName)])
                      .config(RouterConfig)
                      .component(CompanyInfoView, companyInfoView())
                      .name;
